(function () {
  var SIGNATURE_VARIANT_ID = 41742830829768;
  var PROMO_PROP_NAME = '_promo';
  var PROMO_PROP_VALUE = 'bogo-promo-gift';
  var PLAN_IN_BODY = /("?selling_plan"?\s*[:=]\s*"?)(\d+)/;
  var LINE_IN_BODY = /"?\bid"?\s*[:=]\s*"?(\d+)/;

  function getCartEl() {
    return document.getElementById('rebuy-cart');
  }

  function hideBadge() {
    var el = getCartEl();
    if (el) el.classList.remove('gwp-badge-active');
  }

  function syncBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = Array.isArray(cart.items) ? cart.items : [];

        var giftItems = items.filter(function (item) {
          return Number(item.variant_id) === SIGNATURE_VARIANT_ID &&
            (item.properties || {})[PROMO_PROP_NAME] === PROMO_PROP_VALUE;
        });
        var giftQty = giftItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);

        var manualCount = items.filter(function (item) {
          return Number(item.variant_id) === SIGNATURE_VARIANT_ID &&
            (item.properties || {})[PROMO_PROP_NAME] !== PROMO_PROP_VALUE;
        }).length;

        var valid = giftQty > 0 && manualCount >= giftQty;
        var el = getCartEl();
        if (el) el.classList.toggle('gwp-badge-active', valid);
      })
      .catch(function () {});
  }

  function requestUrl(input) {
    return typeof input === 'string' ? input : (input && input.url) || '';
  }

  var _fetch = window.fetch;

  function livePlanFor(variantId) {
    return _fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = (cart.items || []).filter(function (i) { return i.variant_id === variantId; })[0];
        return line ? _fetch('/products/' + line.handle + '.js') : null;
      })
      .then(function (r) { return r ? r.json() : null; })
      .then(function (product) {
        var variant = product && (product.variants || []).filter(function (v) { return v.id === variantId; })[0];
        var alloc = variant && (variant.selling_plan_allocations || [])[0];
        return alloc ? alloc.selling_plan_id : null;
      })
      .catch(function () { return null; });
  }

  /* Recharge mints a new Shopify selling_plan id whenever a plan is toggled.
     Rebuy's cart still posts the old id, so Shopify rejects the upgrade. */
  function replayWithLivePlan(res, input, init) {
    var body = init && init.body;
    if (typeof body !== 'string') return Promise.resolve(res);

    var stale = (body.match(PLAN_IN_BODY) || [])[2];
    var variantId = Number((body.match(LINE_IN_BODY) || [])[1]);
    if (!stale || !variantId) return Promise.resolve(res);

    return res.clone().json().then(function (err) {
      if (!/selling plan/i.test(err.description || '')) return res;
      return livePlanFor(variantId).then(function (live) {
        if (!live || String(live) === stale) return res;
        return _fetch(requestUrl(input), Object.assign({}, init, {
          body: body.replace(PLAN_IN_BODY, '$1' + live)
        }));
      });
    }).catch(function () { return res; });
  }

  window.fetch = function (input, init) {
    var url = requestUrl(input);
    if (!/\/cart\/(add|change|update|clear)\.js/.test(url)) return _fetch.apply(this, arguments);

    hideBadge();
    return _fetch.apply(this, arguments).then(function (res) {
      var settled = (res.status === 422 && /\/cart\/(change|update)\.js/.test(url))
        ? replayWithLivePlan(res, input, init)
        : Promise.resolve(res);
      return settled.then(function (finalRes) {
        setTimeout(syncBadge, 600);
        return finalRes;
      });
    });
  };

  document.addEventListener('rebuy:cart.change', hideBadge);
  document.addEventListener('rebuy:cart.ready', syncBadge);
  document.addEventListener('rebuy:cart.updated', syncBadge);
  document.addEventListener('rebuy:cart.open', syncBadge);

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(syncBadge, 1200);
  });
})();
